import { useAuth } from '@/auth/useAuth';
import { Header } from '@/components/layout';
import { getDefaultPathForRole } from '@/auth/redirects';
import { Button } from '@/components/ui';
import type { UserRole } from '@/types/types';
import { useNavigate } from 'react-router-dom';

export function AccessDeniedPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const role = user?.asesor?.rol as UserRole | undefined;

  return (
    <>
      {user && <Header />}
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center p-8">
          <div className="mb-6">
            <svg className="mx-auto h-16 w-16 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <title>Icono de advertencia</title>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Acceso Denegado</h1>
          <p className="text-gray-600 mb-6">No tienes permisos para acceder a esta página.</p>
          <Button onClick={() => navigate(getDefaultPathForRole(role))}>Volver al Inicio</Button>
        </div>
      </div>
    </>
  );
}
